import React, { useState } from "react";

const Services = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    currentAge: '',
    retirementAge: '',
    currentSavings: '',
    monthlyContribution: '',
    annualReturn: ''
  });
  const [result, setResult] = useState('');

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const submitAndCalculate = () => {
    const {
      name,
      email,
      currentAge,
      retirementAge,
      currentSavings,
      monthlyContribution,
      annualReturn
    } = formData;

    // Input validation
    if (!name || !email || !currentAge || !retirementAge || !currentSavings || !monthlyContribution || !annualReturn) {
      setResult({ text: 'Please fill in all fields with valid values.', color: 'red' });
      return;
    }

    const age = parseInt(currentAge);
    const retAge = parseInt(retirementAge);
    const savings = parseFloat(currentSavings);
    const monthly = parseFloat(monthlyContribution);
    const annual = parseFloat(annualReturn);

    if (retAge <= age) {
      setResult({ text: 'Retirement age must be greater than current age.', color: 'red' });
      return;
    }

    if (age < 0 || retAge < 0 || savings < 0 || monthly < 0 || annual < 0) {
      setResult({ text: 'Please enter only positive values.', color: 'red' });
      return;
    }

    if (annual > 20) {
      setResult({ text: 'Please enter a realistic annual return (0-20%).', color: 'red' });
      return;
    }

    const yearsToInvest = retAge - age;
    const monthsToInvest = yearsToInvest * 12;
    const monthlyReturn = (annual / 100) / 12;

    let futureValue = savings * Math.pow(1 + monthlyReturn, monthsToInvest);
    for (let i = 1; i <= monthsToInvest; i++) {
      futureValue += monthly * Math.pow(1 + monthlyReturn, monthsToInvest - i);
    }

    setResult({ text: `Estimated Retirement Savings: $${futureValue.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`, color: '#004a99' });
    console.log("Lead Captured:", { name, email });
  };

  return (
    <div>
      <style>
        {`
          #retirement-calculator {
            font-family: Arial, sans-serif;
           
            margin: 0;
            padding: 0;
          }
          #retirement-calculator .calculator {
            max-width: 500px;
            margin: 40px auto;
            background-color: white;
            padding: 30px;
            border-radius: 12px;
            box-shadow: 0 0 15px rgba(0,0,0,0.1);
          }
          #retirement-calculator h2 {
            text-align: center;
            color: #004a99;
          }
          #retirement-calculator label {
            display: block;
            margin: 10px 0 5px;
            color: #333;
          }
          #retirement-calculator input {
            width: 100%;
            padding: 10px;
            margin-bottom: 15px;
            border-radius: 6px;
            border: 1px solid #ccc;
          }
          #retirement-calculator button {
            width: 100%;
            padding: 12px;
            background-color: #004a99;
            color: white;
            border: none;
            border-radius: 6px;
            font-size: 16px;
            cursor: pointer;
          }
          #retirement-calculator button:hover {
            background-color: #003570;
          }
          #retirement-calculator .result {
            text-align: center;
            margin-top: 20px;
            font-size: 18px;
            font-weight: bold;
            color: #004a99;
          }
          #retirement-calculator .logo {
            text-align: center;
            margin-bottom: 20px;
          }
          #retirement-calculator .logo img {
            width: 200px;
          }
          #retirement-calculator .footer {
            text-align: center;
            margin-top: 40px;
            font-size: 12px;
            color: #777;
          }
        `}
      </style>

      {/* Breadcrumbs */}
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>Find Your Best Annuity</h2>
                <ul className="bread-list">
                  <li><a href="/">Home</a></li>
                  <li><i className="icofont-simple-right"></i></li>
                  <li className="active">Retirement Calculator</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Breadcrumbs */}

      {/* Start Services Section */}
      <section className="services section">
        <div className="container">
        <div id="retirement-calculator">
          <div className="calculator">
          
            <h2>Retirement Calculator</h2>

            <label htmlFor="name">Your Name:</label>
            <input
              type="text"
              id="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />

            <label htmlFor="email">Your Email:</label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />

            <label htmlFor="currentAge">Your Current Age:</label>
            <input
              type="number"
              id="currentAge"
              value={formData.currentAge}
              onChange={handleInputChange}
              required
            />

            <label htmlFor="retirementAge">Your Desired Retirement Age:</label>
            <input
              type="number"
              id="retirementAge"
              value={formData.retirementAge}
              onChange={handleInputChange}
              required
            />

            <label htmlFor="currentSavings">Current Retirement Savings ($):</label>
            <input
              type="number"
              id="currentSavings"
              value={formData.currentSavings}
              onChange={handleInputChange}
              required
            />

            <label htmlFor="monthlyContribution">Monthly Contribution ($):</label>
            <input
              type="number"
              id="monthlyContribution"
              value={formData.monthlyContribution}
              onChange={handleInputChange}
              required
            />

            <label htmlFor="annualReturn">Expected Annual Return (%):</label>
            <input
              type="number"
              step="0.1"
              id="annualReturn"
              value={formData.annualReturn}
              onChange={handleInputChange}
              required
            />

            <button onClick={submitAndCalculate}>Calculate</button>

            {result && (
              <div className="result" style={{ color: result.color }}>
                {result.text}
              </div>
            )}
          </div>

          <div className="footer">
            &copy; 2025 Charlotte Enriquez | Financial Pros Online. All rights reserved.
          </div>
        </div>
        </div>
      </section>
      {/* End Services Section */}
    </div>
  );
};

export default Services;
